import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Question from "../../images/icons/question.svg";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  makeStyles,
} from "@material-ui/core";
import moment from "moment";

const useStyles = makeStyles({
  table: {
    minWidth: "100%",
  },
});
const RequisitionObservationModal = ({ handleClose, open, observations }) => {
  const classes = useStyles();

  const formatDate = (date) => {
    var initDate = date ? date.split("T")[0] : null;
    return moment(initDate).format("DD/MM/YYYY");
  };

  return (
    <div>
      <Dialog
        PaperProps={{
          style: { borderRadius: 16, padding: 0, minWidth: "750px" },
        }}
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" style={{ color: "#7EBDCE" }}>
          <div style={{ textAlign: "center" }}>
            <p>Observaciones de Actualización</p>
            <TableContainer component={Paper}>
              <Table className={classes.table} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">Actualización</TableCell>
                    <TableCell align="left">Observación</TableCell>
                    <TableCell align="left">Usuario</TableCell>
                    <TableCell align="left">Fecha</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {observations &&
                    observations.map((row) => (
                      <TableRow key={row.requisitionId}>
                        <TableCell component="th" scope="row" align="left">
                          {row.newStatus}
                        </TableCell>
                        <TableCell align="left">{row.observations}</TableCell>
                        <TableCell align="left">{row.user}</TableCell>
                        <TableCell align="left">
                          {formatDate(row.date)}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </DialogTitle>
        <DialogContent></DialogContent>
        <DialogActions style={{ justifyContent: "space-around" }}>
          <Button
            onClick={() => handleClose(false)}
            color="primary"
            variant="outlined"
            style={{ color: "#7EBDCE", borderColor: "#E1E1E1" }}
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default RequisitionObservationModal;
